// import { Row, Col, Button, Modal, Form, div } from "react-bootstrap";
import DataTable from "react-data-table-component";
import React, { Fragment, useLayoutEffect, useRef } from "react";
import * as Icon from "react-bootstrap-icons";
import { useLocation, useNavigate } from "react-router";
import "../crmComponents/Contacts.css";
import { useState, useEffect, useCallback } from "react";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
//Redux-imports
import { useDispatch, useSelector } from "react-redux";
import {
  deleteLead,
  exportLeadDetails,
  fetchLeadsList,
} from "../../redux/actions/crmActions";
import Loading from "../assetLibComponents/Loading";
import { DebounceInput } from "react-debounce-input";
import { ArrowLeft } from "react-bootstrap-icons/dist";
import { Dialog, Transition } from "@headlessui/react";
import TabManagement from "../TabManagement";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import moment from "moment";
import { DateRange, DateRangePicker } from "react-date-range";
import { fetchJourneyListing } from "../../redux/actions/journeyAction";
import Toast from "../assetLibComponents/shared/Toast";
import { createJourney } from "../../redux/actions/journeyAction";


const JourneyListing = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const journeyList = useSelector((state) => state.journey?.journeyListing);
  const leadsList = useSelector((state) => state.crmLeads?.leadsList?.response);
  const leadsListTotal = useSelector((state) => state.crmLeads?.leadsList?.lead_count);
  const isLoading = useSelector((state) => state.crmLeads.loading);
  const [show, setShow] = useState(false);
  const [tabName, setTabName] = useState("Lead View");
  const [searchValue, setSearchValue] = useState("");




  console.log(journeyList,"journeyList")

  // Tailwind

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const tabs = [
    { name: "Lead View", href: "/Lead-Management", current: true },
    { name: "Account View", href: "/Account", current: false },
  ];
  
  const checkbox = useRef();
  const [checked, setChecked] = useState(false);
  const [page, setPage] = useState(1);
  const currentDate = moment();
  const location = useLocation();
  const [indeterminate, setIndeterminate] = useState(false);
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false)
  const [sortVal, setSortVal] = useState("")
  const [deleteModal, setDeleteModal] = useState(false);
  const [rangeString, setRangeString] = useState(location.state?.startDate ? location.state?.rangeString:"all");
  const [showCalendar, setShowCalendar] = useState(false);
  const [dateRange, setDateRange] = React.useState(location.state?.startDate ? {
    startDate: location.state?.startDate,
    endDate: location.state?.endDate,
  } :{
    startDate: null,
    endDate: null,
  });
  const [selectedDates, setSelectedDates] = React.useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);

  const [showJourneyDialog, setShowJourneyDialog] = useState(false);
  const [journeyName, setJourneyName] = useState("");
  const [selectedSegment, setSelectedSegment] = useState("");

  const [segmentStats, setSegmentStats] = useState({
    totalUsers: 525711,
    knownUsers: 124994,
    unknownUsers: 400718,
    reachableUsers: 348513
  });

  const segments = [
    "All Users",
    "Active Users",
    "Inactive Users", 
    "New Users",
    "Premium Users",
    "Free Users",
    "High Value Customers",
    "At Risk Users",
    "Churned Users",
    "Beta Users"
  ];

  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  
  const handleCreateJourney = () => {
    if (!journeyName.trim()) {
      Toast("Please enter a journey name", "E");
      return;
    }

    if (!selectedSegment) {
      Toast("Please select a segment", "E");
      return;
    }
    // Call the API through Redux action
    dispatch(createJourney(props.authToken, "", journeyName, selectedSegment, onSuccess));
  };

  const onSuccess = (id) => {
    navigate(`/journey/builder/${id}`);
  };

  const handleCalendar = (ranges) => {
    setShowCalendar(false);
    const { startDate, endDate } = selectedDates[0];
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD");

    const formattedRange = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };

    setDateRange(formattedRange);
  };

  const handleCheckboxChange = (obj) => {
    if (selectedPeople.includes(obj)) {
        setSelectedPeople(selectedPeople.filter(item => item !== obj));
      } else {
        setSelectedPeople([...selectedPeople, obj]);
      }
  };

  const handleSelectAll = (e) => {
    setSelectedAll(true);
    setSelectedPeople(leadsList);
  };
  
  const getChars = (str) => {
    if (str === "") {
      return;
    }
    const firstLetters = str
      .split(" ")
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
    return firstLetters;
  };

  const deleteHandleClose = () => {
    setDeleteModal(false);
    setSelectedPeople([]);
  };
  
  const nextPage = (e) => {
    setPage(e);
    dispatch(fetchLeadsList(props.authToken,"",sortVal,e,dateRange?.startDate,
    dateRange?.endDate));
  }

  // Tailwind
  useEffect(() => {
    dispatch(fetchJourneyListing(props.authToken));
  }, []);

  const handleRemoveSearch = (e) => {
    setSearchValue("");
    // dispatch(searchInput(""));
    dispatch(fetchLeadsList(props.authToken, ""));
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    dispatch(fetchLeadsList(props.authToken, e.target.value));
  };



  useEffect(() => {
    setPage(1)
    dispatch(fetchLeadsList(props.authToken,"",sortVal,0,dateRange?.startDate,
    dateRange?.endDate));

  }, [sortVal]);


  useEffect(() => {
    props.pageTypeHandler("Journey");
  }, [])


  return (
    <>
      {isLoading && <Loading />}
      {leadsList && (
        <div className="pt-[5rem] bg-gray-100 h-[100vh]">
        {/*New Heading And Bar */}
          <div className="mx-12 max-sm:mx-4 flex max-sm:block justify-between border-b border-gray-200 mb-3 mt-1 my-auto">
            {/* <TabManagement tabs={tabs} setTabName={setTabName} tabName={tabName} /> */}
            <div className="text-xl font-bold text-gray-900">Journey Listing</div>
            <div className="max-sm:w-full max-sm:pb-2 mb-3 ml-auto">
              <button
                onClick={() => {
                  // navigate(`/journey/builder`);
                  setShowJourneyDialog(true);
                }}
                type="button"
                className="my-auto max-sm:w-[30%] max-sm:justify-center mr-3 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
              >
                + New <p className="max-sm:hidden">Journey</p>
              </button>
              
            </div>
          </div>
          
          <div className="w-full flex justify-between pb-2 px-12 max-sm:px-4">
            <div className="relative rounded-md shadow-sm my-auto w-[30%] max-sm:w-[50%]">
              <DebounceInput
                value={searchValue}
                className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-300 sm:text-sm sm:leading-6"
                placeholder="Search Leads..."
                minLength={3}
                debounceTimeout={500}
                onChange={handleSearch}
              />
              <div className="absolute z-[9] cursor-pointer right-[5%] top-1/4">
                {searchValue && searchValue !== "" ? (
                  <Icon.X
                    className="h-4 w-4 text-gray-400 pointer"
                    onClick={handleRemoveSearch}
                  />
                ) : (
                  <Icon.Search
                    className="h-4 w-4 text-gray-400 cursor-pointer"
                    onClick={handleSearch}
                  />
                )}
              </div>
            </div>
            
          </div>

          
          
          <div className="shadow-[0px_5px_10px_0px_#E5E7EB] pb-1 mt-2 mx-4 sm:mx-6 lg:mx-12 bg-white rounded-lg">
            <div className="flow-root">
              <div className={"overflow-x-auto listing "+(selectedPeople.length > 0 ? "xl:h-[50vh] max-sm:h-[55vh] md:h-[42vh] h-[42vh]" : "xl:h-[58vh] md:h-[50vh] max-sm:h-[60vh] h-[50vh]")}>
                <div className="inline-block min-w-full py-0 align-middle sm:px-6 lg:px-0">
                  <div className="relative">
                    <table className="min-w-full divide-y divide-gray-300 ">
                      <thead className="bg-gray-50 sticky top-0 z-10">
                        <tr className="border-gray-200 border-b">
                          <th
                            scope="col"
                            className="relative px-7 sm:w-12 sm:px-6"
                          >
                          </th>
                            <th
                              scope="col"
                              className="py-3.5 w-3/12 pr-3 text-left text-sm font-semibold text-gray-900"
                            >
                              Name
                            </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Segments
                          </th>
                          {/* <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Company
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Source
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Last Activity
                          </th> */}
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                          </th>
                        </tr>
                      </thead>
                      
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {journeyList?.details?.length > 0 && journeyList?.details?.map((item) => (
                          <tr
                            key={item?.id}
                            className={
                              selectedPeople?.includes(item)
                                ? "bg-cyan-50 border-b border-solid"
                                : undefined
                            }
                          >
                            <td className="relative px-7 sm:w-12 sm:px-6">
                              {/* <input
                                type="checkbox"
                                className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-[var(--brand-primary)] focus:ring-white"
                                checked={selectedPeople?.includes(item)}
                                onChange={() => {
                                  handleCheckboxChange(item);
                                }}
                              /> */}
                            </td>
                            <td
                              onClick={() => {
                                navigate(
                                  `/journey/builder/${item.id}`
                                );
                              }}
                              className={classNames(
                                "whitespace-nowrap flex items-center py-4 pr-3 text-sm font-medium cursor-pointer",
                                selectedPeople?.includes(item)
                                  ? "text-gray-900"
                                  : "text-gray-900"
                              )}
                            >
                              <div className="bg-amber-100 rounded-[50%] flex w-8 h-8 flex-col justify-center items-center gap-[17.5px] shrink-0 p-[12.25px] mr-4">
                                <span className="capitalize text-amber-500 text-center text-base not-italic font-semibold leading-6">{getChars(item?.name || "Unknown")}</span>
                              </div>
                              <div className={(item?.email === "" ? "flex items-center": "")}>
                                {item?.title}
                              </div>
                              
                            </td>
                            <td
                              title={item?.phone}
                              className="whitespace-nowrap px-3 py-4 text-gray-500 cursor-default text-sm not-italic font-normal leading-5"
                            >
                              {item?.segment}
                            </td>
                            <td
                              title={item?.company}
                              className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 cursor-default"
                            >
                                <div className={(item?.company_website === "" ? "flex items-center": "")}>
                                <span title={item?.company} className="text-sm capitalize not-italic font-semibold leading-5">
                                {item?.company?.length > 20
                                  ? `${item?.company.slice(0, 20)}...`
                                  : item?.company}
                                </span>
                                <p title={item?.company_website} className="text-xs not-italic font-normal leading-4">
                                {item?.company_website?.length > 25
                                  ? `${item?.company_website.slice(0, 25)}...`
                                  : item?.company_website}
                                </p>
                              </div>
                            </td>
                            <td
                              title={item?.source}
                              className="whitespace-nowrap capitalize px-3 py-4 text-sm text-gray-500 cursor-default"
                            >
                              {item?.source?.length > 20
                                ? `${item?.source.slice(0, 20)}...`
                                : item?.source}
                            </td>
                            <td
                              title={item?.created_date}
                              className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 cursor-default"
                            >
                              {item?.created_date?.slice(0, 10)}
                            </td>
                            <td className="flex justify-end px-3 py-4 text-right text-sm text-gray-500 cursor-default" >
                              {/* <span onClick={() => handleCheckboxChange(item)}>
                                <Icon.ThreeDotsVertical title="select" className={(selectedPeople.includes(item) ? 'cursor-pointer text-[20px] text-[var(--brand-primary)]':"cursor-pointer text-[20px] text-[#A8A8A8] hover:text-[var(--brand-primary)]")}/>
                              </span> */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    
                    {/* {(leadsList?.length === 0) && (
                      <div className="text-[rgba(33,33,33,0.3)] text-[17px] py-[5%] h-full font-[bolder] font-add text-center">
                        <span className="flex justify-center text-[40px]">
                          <Icon.Inbox />
                        </span>
                        No Data
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* {leadsListTotal > 10 && <div className="flex mx-4 sm:mx-6 lg:mx-12 my-4">
            <div className="me-auto">
              <ResponsivePagination
                current={page}
                total={Math.ceil(leadsListTotal/10)}
                onPageChange={nextPage}
              />
            </div>
          </div>} */}
          
          <Transition.Root show={showJourneyDialog} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={() => setShowJourneyDialog(false)}>
               <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 backdrop-blur-sm transition-opacity" />
              </Transition.Child>
              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl">
                      <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                        <div className="sm:flex sm:items-start">
                          <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                            <Dialog.Title as="h3" className="text-xl font-semibold border-b border-gray-200 pb-2 leading-6 text-gray-900 mb-4">
                              Add Journey 
                            </Dialog.Title>
                            <div className="mt-2 space-y-4">
                              <div>
                                <label className="block text-sm font-medium text-gray-500 mb-1">
                                  Journey Name
                                </label>
                                <input
                                  type="text"
                                  value={journeyName}
                                  onChange={(e) => setJourneyName(e.target.value)}
                                  className="block w-full rounded-md border-0 py-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                />
                              </div>
                              <div>
                                <label className="block text-sm font-medium text-gray-500 mb-1">
                                  Segment
                                </label>
                                <div className="flex gap-2 items-center">
                                <select
                                    value={selectedSegment}
                                    onChange={(e) => setSelectedSegment(e.target.value)}
                                    className="block w-full rounded-md border-0 py-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  >
                                    <option value="" disabled>Select Segment</option>
                                    {segments.map((segment) => (
                                      <option key={segment} value={segment}>{segment}</option>
                                    ))}
                                  </select>
                                  <span className="text-gray-500 mx-2">or</span>
                                  <button
                                    type="button"
                                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-[var(--brand-primary)] border border-[var(--brand-primary)] shadow-sm hover:bg-gray-50"
                                  >
                                    Create New Segment
                                  </button>
                                </div>
                              </div>

                              {/* Segment Statistics Box */}
                              {selectedSegment?.length > 0 &&<div className="mt-4 border border-gray-200 rounded-lg p-4">
                                <div className="grid grid-cols-4 gap-4">
                                  <div>
                                    <div className="text-sm text-gray-500">Total Users:</div>
                                    <div className="text-lg font-semibold">{formatNumber(segmentStats.totalUsers)}</div>
                                  </div>
                                  <div>
                                    <div className="text-sm text-gray-500">Known Users:</div>
                                    <div className="text-lg font-semibold">{formatNumber(segmentStats.knownUsers)}</div>
                                  </div>
                                  <div>
                                    <div className="text-sm text-gray-500">Unknown Users:</div>
                                    <div className="text-lg font-semibold">{formatNumber(segmentStats.unknownUsers)}</div>
                                  </div>
                                  <div className="relative">
                                    <div className="text-sm text-gray-500 flex items-center">
                                      Reachable Users:
                                      <span className="ml-1 group">
                                        <svg className="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                        </svg>
                                        <span className="hidden group-hover:block absolute z-10 w-48 p-2 mt-1 text-sm text-gray-500 bg-white border border-gray-200 rounded-lg shadow-lg">
                                          Users who can be reached through at least one channel
                                        </span>
                                      </span>
                                    </div>
                                    <div className="text-lg font-semibold">{formatNumber(segmentStats.reachableUsers)}</div>
                                  </div>
                                </div>
                                <div className="mt-3 text-sm text-gray-500">
                                  Segment contains all users
                                </div>
                              </div>}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                        <button
                          type="button"
                          className="rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-[#fff] shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)]"
                          onClick={handleCreateJourney}
                        >
                          Next
                        </button>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </div>
      )}
    </>
  );
};

export default JourneyListing;
